import ApiService from "../api";

export default class ComissaoService extends ApiService {

    constructor() {
        super("/api/comissoes");
    }

    gerar(dto) {
        return this.post(`/gerar-comissao`, dto);
    }

    listar(filtros) {
        const params = new URLSearchParams();
        params.append('mes', filtros.mes);
        params.append('ano', filtros.ano);
        if (filtros.filialId) params.append('filialId', filtros.filialId);

        return this.get(`?${params.toString()}`)
    }

    // Dias da competência com dados importados de cada relatório (Greenmile, SAP, escalas, pedidos DA), por filial
    diasImportados(filtros) {
        const params = new URLSearchParams();
        params.append('mes', filtros.mes);
        params.append('ano', filtros.ano);
        if (filtros.filialId) params.append('filialId', filtros.filialId);

        return this.get(`/dias-importados?${params.toString()}`);
    }

    // Registros de um relatório (ESCALAS, GREENMILE, SAP_ENTREGAS, SAP_RETORNO, PEDIDOS_DA) importados num dia e filial
    detalheDiaImportado({ fonte, data, filialId }) {
        const params = new URLSearchParams();
        params.append('fonte', fonte);
        params.append('data', data);
        params.append('filialId', filialId);

        return this.get(`/dias-importados/detalhe?${params.toString()}`);
    }

    // Planilha das comissões de um distribuidor (AUTORIZADO = DA, LOGISTICO = DL) só de quem tem valor a receber
    exportar({ ano, mes, tipoDistribuidor, filialId }) {
        const params = new URLSearchParams();
        params.append('ano', ano);
        params.append('mes', mes);
        params.append('tipoDistribuidor', tipoDistribuidor);
        if (filialId) params.append('filialId', filialId);

        return this.getFile(`/exportar?${params.toString()}`);
    }

    minhaComissao(filtros) {
        const params = new URLSearchParams();
        params.append('mes', filtros.mes);
        params.append('ano', filtros.ano);
        params.append('funcionarioId', filtros.funcionarioId);

        return this.get(`/minha-comissao?${params.toString()}`)
    }

    // Comissões parciais bloqueadas que tocam a competência (protegidas contra geração geral)
    parciaisBloqueadas(filtros) {
        const params = new URLSearchParams();
        params.append('mes', filtros.mes);
        params.append('ano', filtros.ano);
        if (filtros.filialId) params.append('filialId', filtros.filialId);

        return this.get(`/parciais-bloqueadas?${params.toString()}`);
    }

    // Exclui uma comissão parcial (libera os dias para a geração geral)
    excluirParcial(id) {
        return this.delete(`/parciais/${id}`);
    }

    enviarEmail(data) {
        return this.post(`/enviar-email`, data)
    }
}
